import { useCallback } from 'react';
import { DateInput, BooleanInput, NumberInput, FormDataConsumer, minValue, maxValue, useTranslate, required } from 'react-admin';
import { Box } from '@mui/material';
import { validateExpiresAfterStartUtil, validateNotPastDateUtil } from '@/components/accessKeys/validators/validators.jsx';
import { RevokeActionButton, RotateActionButton } from '@/components/accessKeys/buttons/actionButtons.jsx';
import EditIcon from '@/assets/icons/edit-icon.svg?react';
import FormDialog from '@/components/global/drawers/FormDialog.jsx';
import { BulkActionsContainer } from '@/components/global/buttons/bulkButtons.jsx';

const BulkAccessKeyEditDrawer = () => {
    const translate = useTranslate();
    const validateExpiresAfterStart = useCallback((value, allValues) => validateExpiresAfterStartUtil(value, allValues, translate), [translate]);
    const validateNotPastDate = useCallback(value => validateNotPastDateUtil(value, translate), [translate]);

    return (
        <FormDialog title={translate('common.bulkEdit')} startIcon={<EditIcon />} customClass='bulk-dialog--access-key'>
            <Box className='popup-wrapper border-bottom'>
                <Box className='popup-box'>
                    <DateInput
                        className='date-input'
                        name='currentKeyValidFrom'
                        source='currentKeyValidFrom'
                        label={translate('resources.accessKey.labels.currentKeyValidFrom')}
                        fullWidth
                        validate={validateNotPastDate}
                    />
                    <DateInput
                        className='date-input'
                        name='currentKeyExpires'
                        source='currentKeyExpires'
                        label={translate('resources.accessKey.labels.currentKeyExpires')}
                        fullWidth
                        validate={[validateNotPastDate, validateExpiresAfterStart]}
                    />
                    <BooleanInput
                        label={translate('resources.accessKey.labels.autoRotation')}
                        source='autoRotation'
                        name='autoRotation'
                        fullWidth
                        size='small'
                        sx={{
                            '& .MuiFormControlLabel-root': {
                                margin: '0',
                            },
                        }}
                    />
                    <FormDataConsumer>
                        {({ formData }) =>
                            formData.autoRotation ? (
                                <NumberInput
                                    label={translate('resources.accessKey.labels.daysToRotate')}
                                    name='daysToRotate'
                                    source='daysToRotate'
                                    fullWidth
                                    validate={[minValue(1), maxValue(365), required(translate('common.validation.required'))]}
                                    defaultValue={30}
                                />
                            ) : null
                        }
                    </FormDataConsumer>
                </Box>
            </Box>
        </FormDialog>
    );
};

export const AccessKeyBulkActionButtons = () => {
    return (
        <BulkActionsContainer>
            <BulkAccessKeyEditDrawer />
            <RotateActionButton />
            <RevokeActionButton />
        </BulkActionsContainer>
    );
};
